<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 row-container"> 


  <div class="col-md-2 pe-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-admin-sidebar></app-admin-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">
    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Yritys <span *ngIf="company && company.businessName">{{company.businessName}}</span></h2>
            <p>Tässä näet yritykset</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{companies.length}}</h2>
                                <p class="white-text">Yritystä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">+100</h2>
                                <p class="white-text">lääkäriä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">10</h2>
                                <p class="white-text">Avattua profiilia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>


  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 mt-4 col-md-10 p-0 input-cover ">
        <div class="col-12 d-flex">
            <button class="btn btn-formed-main-black" routerLink="/admins/admin/edit-company/{{routeID}}">Muokkaa yritystä</button>
            <button class="btn btn-formed-main-black ms-2" routerLink="/admins/admin/company-billing/{{routeID}}">Järjestelmän käyttö</button>
            <button class="btn btn-formed-main-black ms-2" routerLink="/admins/admin/company-bills/{{routeID}}">Laskut</button>
            <button class="btn btn-formed-main-black ms-2" routerLink="/admins/admin/company-pricing/{{routeID}}">Hinnoittelu</button>
            <button class="btn btn-formed-main-black ms-2" data-bs-toggle="modal"  data-bs-target="#create-campaign">Pinnaus</button>
    
        </div>
        <div class="" *ngIf="company && company.businessName">
            <h2>Yrityksen tiedot</h2>
            <table class="table align-items-center table-flush">
                <thead class="thead-light">
                    <tr>
                        <th>Tieto</th>
                        <th>Vastaus</th>
    
                    </tr>
                </thead>
                <tbody class="tbody-light">
                    <tr>
                        <tr>
                            <th width="25%">Nimi</th>
                            <td width="75%">{{company.businessName}}</td>
                        </tr>
                        <tr>
                            <th width="25%">Email</th>
                            <td width="75%">{{company.email}}</td>
                        </tr>
                        <tr>
                            <th width="25%">Puhelin</th>
                            <td width="75%">{{company.phone}}</td>
                        </tr>
                        <tr *ngIf="company.vatID">
                            <th width="25%">Y-tunnus</th>
                            <td width="75%">{{company.vatID}}</td>
                        </tr>   
                        <tr *ngIf="company.einvoiceaddress">
                            <th width="25%">Verkkolaskutusosoite</th>
                            <td width="75%">{{company.einvoiceaddress}}</td>
                        </tr> 
                        <tr *ngIf="company.operator">
                            <th width="25%">Operaattori</th>
                            <td width="75%">{{company.operator}}</td>
                        </tr>
                        <tr *ngIf="company.pinning_expires">
                            <th width="25%">Pinnaus päättyy</th>
                            <td width="75%">{{company.pinning_expires}}</td>
                        </tr>    
                </tbody>
    
            </table>
        </div>
        <h2 class="mt-4">Yrityksen käyttäjät</h2>
        <table class="table table-striped">
            <thead>
                <tr>
                    <td>Viim.Kirjaut.</td>
                    <td>Nimi</td>
                    <td>Email</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of users">
                    <td>{{data.currentLogin}}</td>
                    <td>{{data.firstName}} {{data.lastName}}</td>
                    <td>{{data.email}}</td>
                </tr>
            </tbody>
        </table>
        <h2 class="mt-4">Yrityksen alaryhmät</h2>
        <table class="table table-striped">
            <thead>
                <tr>
                    <td>Rekisteröity</td>
                    <td>Nimi</td>
                    <td>ID</td>
                    <td>Tiedot</td>
                    <td>Poista</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of subGroups">
                    <td>{{data.createdDate | formateDate}}</td>
                    <td>{{data.businessName}}</td>
                    <td>{{data.businessID}}</td>
                    <td><button routerLink="/admins/admin/companies/company/company-details/{{data._id}}" class="btn btn-formed-main-black">Tiedot</button></td>
                    <td><button routerLink="/admins/admin/companies/company/company-details/{{data._id}}" class="btn btn-formed-main-black"><i class="fa fa-trash-alt"></i></button></td>

                </tr>
            </tbody>
        </table>
        </div>

        <div class="col-1"></div>
  </div>

  </div>

    </div>


                    <!-- Modal Check before deleting offer -->
                    <button data-bs-toggle="modal" id="create-campaign-btn" data-bs-target="#create-campaign" style="display:none"></button>
                    <div class="modal fade" id="create-campaign" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class=" w-100 modal-title" id="exampleModalLabel">Pinnaus</h5>
                            <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                            <button id="close-confirm-modal-boost" type="button" class="btn-close" data-bs-dismiss="modal">
                                <i class="fal fa-times"></i>
                                </button>
                        </div>
                        <div class="modal-body">
                        
                                <p class="normaltextblue14">Pinnauksella mobiiliappin etusivulle logo kärkeen</p>
                                <p class="normaltextblue14 ">Jos useampia niin järjestys arvotaan</p>

                                <p class="mb-0">Päivähinta</p>
                                <div class=" mb-2 col-12 col-md-12 p-0">
                                    <input type="number" min="0" placeholder="" (keyup)="updateDays()"  id="days-camp" class="form-control" >
                                    
                        
                                    </div>

                                <p class="mb-0">Päivien lukumäärä</p>
                                <div class=" mb-2 col-12 col-md-12 p-0">
                                    <input type="number" min="0" placeholder="" (keyup)="updatePrice()"  id="campaign" class="form-control" >
                                    
                        
                                    </div>
                                    <p class="normaltextblue14">Boosted {{day_price}}€/pv (alv.0%)</p>
    
                                    <p class="semiboldtextblue80016 mb-3">Lisää haluamasi viite (esim. kustannuspaikka)</p>
    
                                    <div class=" mb-2 col-12 col-md-12 p-0">
                                        <input type="text" placeholder="" (keyup)="updatePrice()"  id="cost_center" class="form-control" >
                            
                                        </div>
        
                                <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
                                    <div class="loader mx-auto"></div>
                                    <p class="text-center pt-3">Tietoja tallennetaan...</p>
                                    </div>
    
                                    <div class="d-flex mt-2">
                                    <p class="semiboldtextblue80016 mb-0">Yhteensä:</p>
                                    <p class="normaltextblue80016 mb-0 ms-2">{{price}}€ (alv.0%)</p>
                                </div>
    
                                <div class="text-center col-12 mt-4 ">
                                    <button class="btn btn-formed-main-gold mt-4" (click)="increaseCampaign()">Aloita</button>
                                </div>
    
                            

    
                            
            
            
                        </div>
                        </div>
                    </div>
                    </div>